import { render } from "./SystemSettingsPage.vue?vue&type=template&id=05f4ad7d&scoped=true"
import script from "./SystemSettingsPage.vue?vue&type=script&lang=js"
export * from "./SystemSettingsPage.vue?vue&type=script&lang=js"

import "./SystemSettingsPage.vue?vue&type=style&index=0&id=05f4ad7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f4ad7d"]])

export default __exports__